<template>
  <section>
    <div class="hero background-light">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-1">RSVP</h1>
          <h1 class="title is-4">Would you like to attend?</h1>
          <h2 class="subtitle">We're looking forward to seeing you!</h2>
        </div>
      </div>
    </div>

    <div class="hero is-small background-primary">
      <div class="hero-body">
      </div>
    </div>

    <div class="hero background-light">
      <div class="hero-body">
        <div class="container">
          <form @submit="postRSVP" accept-charset="UTF-8">
            <b-field label="Name">
              <b-input name="name" placeholder="Name" required v-model="name"></b-input>
            </b-field>

            <b-field label="Email">
              <b-input name="email" placeholder="Email" required type="email" v-model="email"></b-input>
            </b-field>

            <b-field label="Phone"></b-field>
            <b-field grouped>
              <b-field>
                <b-select name="countryCode" placeholder="Country code" required v-model="countryCode">
                  <option value="+1">US (+1)</option>
                  <option value="+46">SE (+46)</option>
                  <option value="+44">GB (+44)</option>
                </b-select>
              </b-field>
              <b-field expanded>
                <b-input name="phone" placeholder="Phonenumber" required type="phone" v-model="phone"></b-input>
              </b-field>
            </b-field>

            <div class="block">
              <b-field label="Are you attending?"></b-field>
              <b-radio :native-value="true"
                       name="attending"
                       required
                       type="is-success"
                       v-model="attending">
                Yay!
              </b-radio>
              <b-radio :native-value="false"
                       name="attending"
                       required
                       type="is-danger"
                       v-model="attending">
                Nay
              </b-radio>
              <b-field message="Yay or nay?" type="is-danger"
                       v-if="attendingError && !(this.attending === true || this.attending === false)"></b-field>
            </div>

            <div class="block">
              <b-field label="Bringing a plus one?"></b-field>
              <b-radio :disabled="!attending"
                       :native-value="true"
                       name="plusOne"
                       required
                       v-model="plusOne">
                Yay
              </b-radio>
              <b-radio :disabled="!attending"
                       :native-value="false"
                       name="plusOne"
                       required
                       v-model="plusOne">
                Nay
              </b-radio>
              <b-field message="Yay or nay?"
                       type="is-danger"
                       v-if="attending && plusOneError && !(this.plusOne === true || this.plusOne === false)"></b-field>
            </div>

            <b-field label="Message for the bride and groom">
              <b-input name="message" type="textarea" v-model="message"></b-input>
            </b-field>

            <button :disabled="isPostSuccess" class="button is-link" type="submit">{{!rsvp ? 'Submit' : 'Update'}}
            </button>
          </form>

          <div class="notification-tray">
            <b-notification :closable="false" type="is-success" v-if="isPostSuccess">
              RSVP Sent!
            </b-notification>

            <b-notification :closable="false" type="is-danger" v-if="isPostError">
              Something went wrong. Please try again.
            </b-notification>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'

export default {
  name: 'RSVP',
  data () {
    return {
      name: null,
      email: null,
      countryCode: null,
      phone: null,
      attending: null,
      plusOne: null,
      message: '',
      rsvp: null,
      attendingError: false,
      plusOneError: false,
      isPostSuccess: false,
      isPostError: false
    }
  },
  methods: {
    postRSVP: function (e) {
      if (this.checkForm(e)) {
        e.preventDefault()
        const loadingComponent = this.$loading.open({
          container: null
        })
        if (!this.rsvp) {
          axios.post('/functions/rsvp', {
            name: this.name,
            email: this.email,
            countryCode: this.countryCode,
            phone: this.phone,
            attending: this.attending,
            plusOne: this.plusOne,
            message: this.message
          }).then((response) => {
            console.log(response)
            loadingComponent.close()
            this.isPostSuccess = true

            if (this.attending) {
              this.$snackbar.open({
                duration: 30000,
                message: 'Do you need accommodations?',
                actionText: 'Go to accommodations',
                onAction: () => {
                  this.$router.push({
                    path: 'accommodations',
                    query: {
                      name: this.name,
                      email: this.email
                    }
                  })
                }
              })
            }
          }).catch((error) => {
            console.log(error)
            loadingComponent.close()
            this.isPostError = true
          })
        } else {
          axios.put('/functions/rsvp', {
            rsvp: this.rsvp,
            name: this.name,
            email: this.email,
            countryCode: this.countryCode,
            phone: this.phone,
            attending: this.attending,
            plusOne: this.plusOne,
            message: this.message
          }).then((response) => {
            console.log(response)
            loadingComponent.close()
            this.isPostSuccess = true
          }).catch((error) => {
            console.log(error)
            loadingComponent.close()
            this.isPostError = true
          })
        }
      }
    },
    checkForm: function (e) {
      if (this.attending === true) {
        if (this.plusOne === true || this.plusOne === false) {
          return true
        } else {
          this.plusOneError = true
        }
      } else if (this.attending === false) {
        return true
      } else {
        this.attendingError = true
      }

      e.preventDefault()
      return false
    }
  },
  mounted: function () {
    const db = firebase.firestore()

    // Disable deprecated features
    db.settings({
      timestampsInSnapshots: true
    })

    // db.collection('rsvp').get().then((querySnapshot) => {
    //   querySnapshot.forEach((doc) => {
    //     console.log(`${doc.id} => ${doc.data()}`)
    //   })
    // })

    let rsvp = this.$route.query.rsvp
    if (rsvp) {
      console.log(rsvp)
      const loadingComponent = this.$loading.open({
        container: null
      })
      db.collection('rsvp').doc(rsvp).get().then(doc => {
        if (doc.exists) {
          console.log('Document data:', doc.data())
          this.rsvp = doc.id
          this.name = doc.data().name
          this.email = doc.data().email
          this.countryCode = doc.data().countryCode
          this.phone = doc.data().phone
          this.attending = doc.data().attending
          this.plusOne = doc.data().plusOne
          this.message = doc.data().message
          loadingComponent.close()
        } else {
          // doc.data() will be undefined in this case
          console.log('No such document!')
          loadingComponent.close()
        }
      }).catch(error => {
        console.log('Error getting document:', error)
        loadingComponent.close()
      })
    }
  }
}
</script>

<style scoped>
  .notification-tray {
    margin-top: 10px;
  }
</style>
